import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

export const FIELDWORKER_PAYMENT_GET_ALL = gql(`
  query FieldworkerPaymentGetAll {
    fieldworkerPaymentGetAll {
      id
      paymentDate
      period
      mediaId
      scope
      media {
        id
        name
        mimeType
        isUploaded
        url
      }
      total {
        nightSeconds
        daySeconds
        travelDistanceMeters
      }
    }
}
`);

export default function useFieldworkerPaymentGetAll() {
    const { data, loading, error } = useQuery(FIELDWORKER_PAYMENT_GET_ALL);

    return {
        loading,
        error,
        data: data?.fieldworkerPaymentGetAll,
    };
}
